import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage.service';
import { PopupRealTimeBiddingComponent } from '../../modals/popup-real-time-bidding/popup-real-time-bidding.component';
import { PopupLoginComponent } from '../../modals/popup-login/popup-login.component';
import { AuctionService } from 'src/app/services/auction.service';
import { IAnimal } from 'src/app/models/animal';
import { PopupShoppingComponent } from '../../modals/popup-shopping/popup-shopping.component';
import { IScheduleEvent } from 'src/app/models/schedule_event';
import { IAuctionBid } from 'src/app/models/transactions';

@Component({
  selector: 'app-action-auction',
  templateUrl: './action-auction.component.html',
  styleUrls: ['./action-auction.component.scss'],
})
export class ActionAuctionComponent implements OnInit {
  @Input() animal_obj: IAnimal = {} as IAnimal;

  @Input() auction_bid: IAuctionBid = {} as IAuctionBid;
  @Input() analizing_bid = false;
  @Input() schedule_event: IScheduleEvent = {} as IScheduleEvent;
  @Input() bid_range_array: any = [] as any[];

  @Input() hasBid = false;
  @Input() next_bid = 0;
  @Input() increment = 0;
  @Input() is_live: 'LIVE' | 'DETAILS' = 'LIVE';
  @Output() eventSocket = new EventEmitter<any>();

  constructor(
    private storage: StorageService,
    private dialog: MatDialog,
    private auctionService: AuctionService
  ) {}

  is_login = false;
  attual_bid = -1;
  loading = true;

  timer: number = 3 * 60 * 1000; // 3 minutos
  timerStartCheck = 20 * 60 * 1000; // 20 minutos
  timerToEnd = 0;
  openingTime = 0;

  bid_status: 'FINISH' | 'REAL_TIME' | 'OPEN' | 'CLOSED' = 'CLOSED';
  list_bids: any = [];

  view = {};

  time = { days: 0, hour: 0, min: 0, seg: 0 };
  winning = false;

  user = this.storage.myself;

  ngOnInit(): void {
    console.log('---------DETAILS---------');

    if (this.storage.token && this.storage.token !== '') {
      this.is_login = true;
    }

    this.attual_bid = this.animal_obj.bid;

    this.getListBid();
    this.next_bid = this.animal_obj.bid;
  }

  getListBid() {
    this.auctionService.getListBid(this.animal_obj.id, 'ACEITO').subscribe({
      next: (data) => {
        if (data?.length > 0) {
          this.attual_bid = data[0].value;
        }
        this.list_bids = data;

        let user: any;
        if (this.storage.token && this.storage.token !== '') {
          user = this.storage.myself;
        }

        if (this.list_bids) {
          if (this.list_bids.length > 0) {
            // this.list_bids.forEach((item: any) => {
            if (user?.id === this.list_bids[0].user) {
              if (this.list_bids[0].status === 'AGUARDANDO') {
                this.analizing_bid = true;
                this.winning = true;
              }
              if (this.list_bids[0].status === 'ACEITO') {
                this.winning = true;
              }
            }
            // });
          }
        }

        this.loading = false;

        // this.bid_status = this.auction_bid.status;
        this.getAttualbid();
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  getAttualbid() {
    if (this.bid_range_array.length > 0) {
      this.bid_range_array.forEach((item: any) => {
        if (
          this.attual_bid >= item.initial_value &&
          this.attual_bid <= item.final_value
        ) {
          this.increment = Number(item.increment);
          this.attual_bid += Number(item.increment);
        }
      });
    }
  }

  openPopupPreBid() {
    if (!this.is_login) {
      this.openPopuplogIn();
      return;
    }

    const dialogRef = this.dialog.open(PopupRealTimeBiddingComponent, {
      width: '90%',
      maxWidth: '500px',
      disableClose: true,
      data: {
        id: this.auction_bid.id,
        animal: this.animal_obj,
        increment: this.increment,
        auction_bid: this.auction_bid,
        attual_bid: this.attual_bid || 0,
        next_bid: this.next_bid,
        max_bid: this.attual_bid * 1.3,
        enableBid: true,
        timer: this.timer,
        type: 'PRE_LANCE',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(true);
      }
    });
  }

  openOnlineBidPopup() {
    if (!this.is_login) {
      this.openPopuplogIn();
      return;
    }

    const dialogRef = this.dialog.open(PopupRealTimeBiddingComponent, {
      width: '90%',
      maxWidth: '500px',
      disableClose: true,
      data: {
        id: this.auction_bid.id,
        animal: this.animal_obj,
        increment: this.increment,
        auction_bid: this.auction_bid,
        attual_bid: this.attual_bid || 0,
        next_bid: this.next_bid,
        max_bid: this.attual_bid * 1.3,
        enableBid: true,
        timer: null,
        type: 'LANCE_ONLINE',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(true);
      }
    });
  }

  openPopupBuyShopping() {
    const popupBuyRef = this.dialog.open(PopupShoppingComponent, {
      width: '90%',
      maxWidth: '500px',
      data: {
        id: this.auction_bid.id,
        auction: this.animal_obj,
      },
    });
    popupBuyRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.auctionService
          .postAuctionBid(this.animal_obj.id, result.results)
          .subscribe(
            (data) => {
              this.eventSocket.emit(true);
            },
            (error) => {
              console.error(error);
            }
          );
      }
    });
  }

  openPopuplogIn() {
    const popupLoginRef = this.dialog.open(PopupLoginComponent, {
      width: '90%',
      maxWidth: '400px',
    });
    popupLoginRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        this.eventSocket.emit(false);
      }
    });
  }
}
